import styled, { css } from "../../styled-components.mjs";
import { cssLayoutMargin, cssSpacing, defaultTheme } from "../../styles/index.mjs";
export var Footer = styled.footer.withConfig({
  displayName: "Footer",
  componentId: "sc-1bh5yaq-0"
})(["border-block-start:1px solid ", ";position:relative;", ""], function (props) {
  return "var(--decorative-subdued, ".concat(defaultTheme[props.colorSet].decorative.subdued, ")");
}, function (props) {
  return !props.hasFooterStyleReset && css(["padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";> *{align-items:center;display:flex;justify-content:space-between;}"], cssSpacing('base', '16px'), cssSpacing('base', '16px'), cssLayoutMargin('base', '24px'), cssLayoutMargin('base', '24px'));
});